import { render } from "./PasswordUpdate.vue?vue&type=template&id=14620914&scoped=true"
import script from "./PasswordUpdate.vue?vue&type=script&lang=js"
export * from "./PasswordUpdate.vue?vue&type=script&lang=js"

import "./PasswordUpdate.vue?vue&type=style&index=0&id=14620914&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14620914"]])

export default __exports__